import { Deserializable } from 'rome-library';

export class NotificationCheckDto implements Deserializable {
  public ShouldRefreshMessageNotification: boolean;
  public NotificationCheckTime: string;
  public CasesAssigned: number;

  public deserialize(input: any): this {
    this.ShouldRefreshMessageNotification = input.shouldRefreshMessageNotification;
    this.NotificationCheckTime = input.notificationCheckTime;
    this.CasesAssigned = input.casesAssigned;

    return this;
  }
}
